import { useEffect, useState } from "react";
import API_URL from "../const";

import Headers from "../Components/HeaderPrivate";

function InfoPage() {
  const [infoConexiones, setInfoConexiones] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}getConexion.php`)
      .then((response) => response.text())
      .then((text) => {
        try {
          const responseData = JSON.parse(text);
          setInfoConexiones(responseData);
        } catch (error) {
          console.error("Error al analizar JSON:", error);
        }
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
      });
  }, []);

  return (
    <div className="fixed left-0 right-0">
      <Headers></Headers>
      <div className="mt-20 mx-10">
        {infoConexiones && (
          <div className="border border-gray-200 rounded-lg">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex items-center justify-between w-full p-4 bg-gray-50 hover:bg-gray-100 rounded-t-lg text-left"
            >
              <div className="flex justify-between w-full">
                <p className="mr-10">{infoConexiones.nombre_empresas}</p>
                <p>{`${new Date(infoConexiones.datos[0].fecha).toLocaleDateString()} - ${new Date(infoConexiones.datos[0].fecha).toLocaleTimeString()}`}</p>
              </div>
              <svg className={`w-4 h-4 ml-2 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {isOpen && (
              <div className="p-4 border-t border-gray-200">
                {infoConexiones.datos.map((dato, index) => (
                  <div className="w-full" key={index}>
                    <div className="flex justify-between m-1">
                      <div className="flex"><h1 className="mr-3 font-semibold">ID</h1> <p>{dato.id}</p></div>
                      <div className="text-right"><h1 className="font-semibold">Nombre</h1> <p>{dato.nombre}</p></div>
                    </div>
                    <div className="flex justify-between m-1">
                      <div className="flex"><h1 className="font-bold mr-2">Fecha</h1> {dato.fecha}</div>
                      <div className="text-right"><h1 className="font-semibold">Descripción</h1> <p>{dato.descripcion}</p></div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
export default InfoPage;